import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router'
import { useCallable } from '@/data/hooks'
import { Notice } from '@/ui'
import { useAuth } from './AuthProvider'
import { SignInPage } from './SignInPage'

/** Landing for /invite/:inviteId. Unauthenticated → sign-in; authenticated → accept and go. */
export function InvitePage() {
  const { inviteId } = useParams()
  const { user, loading, refreshClaims } = useAuth()
  const accept = useCallable<{ inviteId?: string }, { clientIds: string[] }>('acceptInvite')
  const [result, setResult] = useState<{ clientId?: string; error?: string } | null>(null)

  useEffect(() => {
    if (!user || !inviteId || result) return
    accept({ inviteId })
      .then(async (r) => {
        await refreshClaims()
        setResult({ clientId: r.clientIds[0] })
      })
      .catch((e: { message?: string }) => setResult({ error: e.message?.replace(/^.*?:\s*/, '') ?? 'This invitation is no longer valid.' }))
  }, [user, inviteId, accept, refreshClaims, result])

  if (loading) return null
  if (!user) return <SignInPage />
  if (result?.clientId) return <Navigate to={`/c/${result.clientId}`} replace />
  if (result?.error)
    return (
      <main id="main" className="grid min-h-dvh place-items-center px-6">
        <Notice tone="danger" className="max-w-md">{result.error}</Notice>
      </main>
    )
  return (
    <main id="main" className="grid min-h-dvh place-items-center px-6">
      <p className="text-eyebrow uppercase tracking-eyebrow text-dim">Opening your portal…</p>
    </main>
  )
}
